<template>
  <div class="home">
    <h1>Price monitor</h1>
    <p>Applicazione per monitorare i prezzi dei concorrenti.</p>
    <router-link v-bind:to="'/login'" class="nav-link" v-if="!username">Entra nell'app</router-link>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue